import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const getFeedBackData = createAsyncThunk("getFeedBackData", async ({ page, limit }) => {
    const response = await API.get('listfeedbacks', {
      params: { page, limit }
    });
    return response.data;
  });
